import {
  getNodegroupDetail,
  getNodegroups,
  startNodeGroup,
  stopNodeGroup,
  createNodegroup,
  updateNodegroup,
  deleteNodeGroup,
  retryCreateNodeGroup,
} from "@/apis";

export const RESOURCE_TYPE_NODEGROUPS = "nodegroups";

const handleResponse = (response) => {
  if (response.status === "error" || response.status === "Error") {
    throw new Error(response.error);
  } else {
    return response.value;
  }
};

export const NodegroupsDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await getNodegroups();
    const data = response.value;
    return {
      data,
      total: data.length,
    };
  },
  getOne: async ({ resource, id, meta }) => {
    const response = await getNodegroupDetail(id);
    return handleResponse(response);
  },

  create: async ({ resource, variables, meta }) => {
    const data = await createNodegroup(variables);
    return { data };
  },
  update: async ({ resource, id, variables: { action, data } }) => {
    if (action === "stop") {
      const resp = await stopNodeGroup(id);
      return handleResponse(resp);
    } else if (action === "start") {
      const resp = await startNodeGroup(id);
      return handleResponse(resp);
    } else if (action === "update" || action === "changeNodegroup") {
      const resp = await updateNodegroup(id, data);
      return handleResponse(resp);
    } else if (action === "retry") {
      const resp = await retryCreateNodeGroup(id);
      return handleResponse(resp);
    }
  },
  deleteOne: async ({ resource, id }) => {
    const resp = await deleteNodeGroup(id);
    return handleResponse(resp);
  },
  getApiUrl: () => {
    throw new Error("Function not implemented.");
  },
};
